<div class="custom-space"></div>
<div *ngIf="vm.showProgressBar">
  <div class="lmask"></div>
</div>
<mat-toolbar class="mat-toolbar text-black toolbar-font toolbar-section">
  <div class="full-width">
    <p class="mb-0"><span aria-hidden="true" class="fa fa-book icon"></span> Asset Detailed View</p>
  </div>
</mat-toolbar>
<div class="custom-space"></div>
<div *ngIf="vm.progressAfterLoad">
  <mat-toolbar class="asset-details-font asset-info">
    <mat-toolbar-row>
      <p class="heading-text mt-3"><span class="text-type-bold">QR Code Asset Id:</span> {{vm.params?.assetId}}</p>
    </mat-toolbar-row>
    <mat-toolbar-row>
      <p class="heading-text">
        <span class="text-type-bold">Type:</span>
        {{vm.params?.assetType === vm.PowerSupplyAssetType.FuelTank ? 'Fuel Tank' : (vm.params?.assetType | titlecase)}}
      </p>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="custom-space"></div>
  <div class="padding-bottom-50">
    <mat-accordion>
      <!-- Asset Information Expansion Panel -->
      <mat-expansion-panel>
        <mat-expansion-panel-header class="height-45">
          <mat-panel-title>
            <p class="mb-0">
              <span class="generator-accord-font text-type-bold">
                {{(vm.params?.assetType === vm.PowerSupplyAssetType.FuelTank ? 'Fuel Tank' : (vm.params?.assetType | titlecase))}} Information
              </span>
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="custom-space"></div>
        <mat-toolbar class="subheader-section">
          <div class="generator-accord-sub-font">
            <p class="mb-0 text-type-bold">
              <span class="fa fa-info-circle fa-lg pr-2"></span>
              Asset Info
            </p>
          </div>
        </mat-toolbar>
        
        <!-- Generator Information -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.Generator" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">QR Code Asset Id:</span> {{vm.generatorData?.qrCodeId ? vm.generatorData.qrCodeId : 'N/A'}}</p>
            <p><span class="text-type-bold">Local ID:</span> {{vm.generatorData?.localId ? vm.generatorData.localId : 'N/A'}}</p>
            <p><span class="text-type-bold">Status:</span> {{vm.generatorData?.generatorStatus ? vm.generatorData.generatorStatus : 'N/A'}}</p>
            <p><span class="text-type-bold">Serial Number:</span> {{vm.generatorData?.generatorSerialNumber ? vm.generatorData.generatorSerialNumber : 'N/A'}}</p>
            <p><span class="text-type-bold">Manufacturer:</span> {{vm.generatorData?.generatorManufacturer ? vm.generatorData.generatorManufacturer : 'N/A'}}</p>
            <p><span class="text-type-bold">Model:</span> {{vm.generatorData?.generatorModel ? vm.generatorData.generatorModel : 'N/A'}}</p>
            <p><span class="text-type-bold">Current Type:</span> {{vm.generatorData?.currentType ? vm.generatorData.currentType : 'N/A'}}</p>
            <p><span class="text-type-bold">Output Voltage:</span> {{vm.generatorData?.outputVoltage ? vm.generatorData.outputVoltage : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified:</span> {{vm.generatorData?.generatorLastModified ? (vm.generatorData.generatorLastModified | date:'MM-dd-yyyy') : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified By:</span> {{vm.generatorData?.generatorLastModifiedBy ? vm.generatorData.generatorLastModifiedBy : 'N/A'}}</p>
            <p><span class="text-type-bold">Generator Created By:</span> {{vm.generatorData?.createdByUserId ? vm.generatorData.createdByUserId : 'N/A'}}</p>
            <p><span class="text-type-bold">Owner & Contact:</span> {{vm.generatorData?.ownerContact ? vm.generatorData.ownerContact : 'N/A'}}</p>
            <p><span class="text-type-bold">Owner Team:</span> {{vm.generatorData?.teamName ? vm.generatorData.teamName : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Name:</span> {{vm.trailerName ? vm.trailerName : 'N/A'}}</p>
            <p><span class="text-type-bold">Loaned to Team:</span> {{vm.generatorData?.loanedTeamName ? vm.generatorData.loanedTeamName : 'N/A'}}</p>
            <p><span class="text-type-bold">Maintenance:</span> {{vm.generatorData?.maintenance ? vm.generatorData.maintenance : 'N/A'}}</p>
            <p><span class="text-type-bold">Generator RunTime (In Minutes):</span> {{(vm.generatorMinutesRuntime === 0 || vm.generatorMinutesRuntime) ? vm.generatorMinutesRuntime : 'N/A'}}</p>
            <p><span class="text-type-bold">Generator Lock:</span> {{vm.generatorData?.generatorLock ? vm.generatorData.generatorLock : 'N/A'}}</p>
            <p><span class="text-type-bold">Generator Cord:</span> {{vm.generatorData?.generatorCord ? vm.generatorData.generatorCord : 'N/A'}}</p>
            <p><span class="text-type-bold">Generator Chain:</span> {{vm.generatorData?.generatorChain ? vm.generatorData.generatorChain : 'N/A'}}</p>
            <p><span class="text-type-bold">Comments:</span> {{vm.generatorData?.comments ? vm.generatorData.comments : 'N/A'}}</p>
          </div>
        </div>

        <!-- Fuel Tank Information -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.FuelTank" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">QR Code Asset Id:</span> {{vm.fuelTankData?.qrCodeId ? vm.fuelTankData.qrCodeId : 'N/A'}}</p>
            <p><span class="text-type-bold">Local ID:</span> {{vm.fuelTankData?.localId ? vm.fuelTankData.localId : 'N/A'}}</p>
            <p><span class="text-type-bold">Status:</span> {{vm.fuelTankData?.status ? vm.fuelTankData.status : 'N/A'}}</p>
            <p><span class="text-type-bold">Serial Number:</span> {{vm.fuelTankData?.serialNumber ? vm.fuelTankData.serialNumber : 'N/A'}}</p>
            <p><span class="text-type-bold">Capacity (Gallons):</span> {{vm.fuelTankData?.capacity ? vm.fuelTankData.capacity : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified:</span> {{vm.fuelTankData?.lastModifiedDate ? (vm.fuelTankData.lastModifiedDate | date:'MM-dd-yyyy') : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified By:</span> {{vm.fuelTankData?.lastModifiedByUserId ? vm.fuelTankData.lastModifiedByUserId : 'N/A'}}</p>
            <p><span class="text-type-bold">Fuel Tank Created By:</span> {{vm.fuelTankData?.createdByUserId ? vm.fuelTankData.createdByUserId : 'N/A'}}</p>
            <p><span class="text-type-bold">Owner Team:</span> {{vm.fuelTankData?.teamName ? vm.fuelTankData.teamName : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Name:</span> {{vm.fuelTankData?.trailerName ? vm.fuelTankData.trailerName : 'N/A'}}</p>
            <p><span class="text-type-bold">Loaned to Team:</span> {{vm.fuelTankData?.loanedToTeam ? vm.fuelTankData.loanedToTeam : 'N/A'}}</p>
            <p><span class="text-type-bold">Comments:</span> {{vm.fuelTankData?.comments ? vm.fuelTankData.comments : 'N/A'}}</p>
          </div>
        </div>

        <!-- Trailer Information -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.Trailer" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">QR Code Asset Id:</span> {{vm.trailerData?.qrCodeId ? vm.trailerData.qrCodeId : 'N/A'}}</p>
            <p><span class="text-type-bold">Local ID:</span> {{vm.trailerData?.localId ? vm.trailerData.localId : 'N/A'}}</p>
            <p><span class="text-type-bold">Status:</span> {{vm.trailerData?.status ? vm.trailerData.status : 'N/A'}}</p>
            <p><span class="text-type-bold">Serial Number:</span> {{vm.trailerData?.serialNumber ? vm.trailerData.serialNumber : 'N/A'}}</p>
            <p><span class="text-type-bold">CDL Required:</span> {{vm.trailerData?.cdlRequired === 1 ? 'Yes' : (vm.trailerData?.cdlRequired === 0 ? 'No' : 'N/A')}}</p>
            <p><span class="text-type-bold">Generator Capacity:</span> {{vm.trailerData?.generatorCapacity ? vm.trailerData.generatorCapacity : 'N/A'}}</p>
            <p><span class="text-type-bold">License Plate:</span> {{vm.trailerData?.licensePlate ? vm.trailerData.licensePlate : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified:</span> {{vm.trailerData?.trailerLastModifiedDate ? (vm.trailerData.trailerLastModifiedDate | date:'MM-dd-yyyy') : 'N/A'}}</p>
            <p><span class="text-type-bold">Last Modified By:</span> {{vm.trailerData?.trailerLastModifiedByUserId ? vm.trailerData.trailerLastModifiedByUserId : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Created By:</span> {{vm.trailerData?.trailerCreatedByUserId ? vm.trailerData.trailerCreatedByUserId : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Name:</span> {{vm.trailerData?.trailerName ? vm.trailerData.trailerName : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Height:</span> {{vm.trailerData?.trailerHeight ? vm.trailerData.trailerHeight : 'N/A'}}</p>
            <p><span class="text-type-bold">Trailer Size:</span> {{vm.trailerData?.trailerSize ? vm.trailerData.trailerSize : 'N/A'}}</p>
            <p><span class="text-type-bold">Hitch Size:</span> {{vm.trailerData?.hitchSize ? vm.trailerData.hitchSize : 'N/A'}}</p>
            <p><span class="text-type-bold">Hitch Type:</span> {{vm.trailerData?.hitchType ? vm.trailerData.hitchType : 'N/A'}}</p>
            <p><span class="text-type-bold">Lock Combination:</span> {{vm.trailerData?.lockCombination ? vm.trailerData.lockCombination : 'N/A'}}</p>
            <p><span class="text-type-bold">Lock Type:</span> {{vm.trailerData?.lockType ? vm.trailerData.lockType : 'N/A'}}</p>
            <p><span class="text-type-bold">Primary Contact:</span> {{vm.trailerData?.primaryContact ? vm.trailerData.primaryContact : 'N/A'}}</p>
            <p><span class="text-type-bold">Secondary Contact:</span> {{vm.trailerData?.secondaryContact ? vm.trailerData.secondaryContact : 'N/A'}}</p>
            <p><span class="text-type-bold">Owner Team:</span> {{vm.trailerData?.teamName ? vm.trailerData.teamName : 'N/A'}}</p>
            <p><span class="text-type-bold">Loaned to Team:</span> {{vm.trailerData?.trailerLoanedTeamId ? vm.trailerData.trailerLoanedTeamId : 'N/A'}}</p>
            <p><span class="text-type-bold">Away from home:</span> {{vm.trailerData?.awayFromHome === 1 ? 'Yes' : (vm.trailerData?.awayFromHome === 0 ? 'No' : 'N/A')}}</p>
            <p><span class="text-type-bold">Comments:</span> {{vm.trailerData?.comments ? vm.trailerData.comments : 'N/A'}}</p>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Location Information Expansion Panel -->
      <mat-expansion-panel>
        <mat-expansion-panel-header class="height-45">
          <mat-panel-title>
            <p class="mb-0">
              <span class="generator-accord-font text-type-bold">Show Location</span>
            </p>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="custom-space"></div>
        <mat-toolbar class="subheader-section">
          <div class="generator-accord-sub-font">
            <p class="mb-0 text-type-bold">
              <span class="fa fa-info-circle fa-lg pr-2"></span>
              Location Info
            </p>
          </div>
        </mat-toolbar>

        <!-- Generator Location -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.Generator" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">Division:</span> {{vm.generatorData?.division ? vm.generatorData.division : 'N/A'}}</p>
            <p><span class="text-type-bold">Region:</span> {{vm.generatorData?.region ? vm.generatorData.region : 'N/A'}}</p>
            <p><span class="text-type-bold">Address:</span> {{vm.generatorData?.address ? vm.generatorData.address : 'N/A'}}</p>
            <p><span class="text-type-bold">City:</span> {{vm.generatorData?.city ? vm.generatorData.city : 'N/A'}}</p>
            <p><span class="text-type-bold">State:</span> {{vm.generatorData?.state ? vm.generatorData.state : 'N/A'}}</p>
            <p><span class="text-type-bold">Zip Code:</span> {{vm.generatorData?.zipcode ? vm.generatorData.zipcode : 'N/A'}}</p>
            <p><span class="text-type-bold">Latitude:</span> {{vm.generatorData?.latitude ? vm.generatorData.latitude : 'N/A'}}</p>
            <p><span class="text-type-bold">Longitude:</span> {{vm.generatorData?.longitude ? vm.generatorData.longitude : 'N/A'}}</p>
          </div>
        </div>

        <!-- Fuel Tank Location -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.FuelTank" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">Division:</span> {{vm.fuelTankData?.division ? vm.fuelTankData.division : 'N/A'}}</p>
            <p><span class="text-type-bold">Region:</span> {{vm.fuelTankData?.region ? vm.fuelTankData.region : 'N/A'}}</p>
            <p><span class="text-type-bold">Address:</span> {{vm.fuelTankData?.address ? vm.fuelTankData.address : 'N/A'}}</p>
            <p><span class="text-type-bold">City:</span> {{vm.fuelTankData?.city ? vm.fuelTankData.city : 'N/A'}}</p>
            <p><span class="text-type-bold">State:</span> {{vm.fuelTankData?.state ? vm.fuelTankData.state : 'N/A'}}</p>
            <p><span class="text-type-bold">Zip Code:</span> {{vm.fuelTankData?.zipCode ? vm.fuelTankData.zipCode : 'N/A'}}</p>
            <p><span class="text-type-bold">Latitude:</span> {{vm.fuelTankData?.latitude ? vm.fuelTankData.latitude : 'N/A'}}</p>
            <p><span class="text-type-bold">Longitude:</span> {{vm.fuelTankData?.longitude ? vm.fuelTankData.longitude : 'N/A'}}</p>
          </div>
        </div>

        <!-- Trailer Location -->
        <div *ngIf="vm.params?.assetType === vm.PowerSupplyAssetType.Trailer" class="generator-accord-font w3-row-padding">
          <div class="wrapper-loc">
            <p><span class="text-type-bold">Division:</span> {{vm.trailerData?.division ? vm.trailerData.division : 'N/A'}}</p>
            <p><span class="text-type-bold">Region:</span> {{vm.trailerData?.region ? vm.trailerData.region : 'N/A'}}</p>
            <p><span class="text-type-bold">House Number:</span> {{vm.trailerData?.houseNumber ? vm.trailerData.houseNumber : 'N/A'}}</p>
            <p><span class="text-type-bold">Street:</span> {{vm.trailerData?.street ? vm.trailerData.street : 'N/A'}} &nbsp;
              <a
                *ngIf="vm.trailerData?.street"
                href="https://www.google.com/maps/place/{{vm.trailerData?.houseNumber}}+{{vm.trailerData?.street}}+{{vm.trailerData?.city}}+{{vm.trailerData?.state}}+{{vm.trailerData?.zipCode}}"
                matTooltip="Show on Map"
                rel="noopener noreferrer"
                target="_blank"
              >
                <mat-icon>location_on</mat-icon>
              </a>
            </p>
            <p><span class="text-type-bold">City:</span> {{vm.trailerData?.city ? vm.trailerData.city : 'N/A'}}</p>
            <p><span class="text-type-bold">State:</span> {{vm.trailerData?.state ? vm.trailerData.state : 'N/A'}}</p>
            <p><span class="text-type-bold">Zip Code:</span> {{vm.trailerData?.zipCode ? vm.trailerData.zipCode : 'N/A'}}</p>
            <p><span class="text-type-bold">Latitude:</span> {{vm.trailerData?.currentLatitude ? vm.trailerData.currentLatitude : 'N/A'}}</p>
            <p><span class="text-type-bold">Longitude:</span> {{vm.trailerData?.currentLongitude ? vm.trailerData.currentLongitude : 'N/A'}}</p>
          </div>
        </div>
      </mat-expansion-panel>

    </mat-accordion>
  </div>
</div>
